type ApiConfig = {
  baseUrl: string
}

export const apiConfig: ApiConfig = {
  baseUrl: '/dhl-extra-api',
}

export const configureDhlExtraApi = (config: Partial<ApiConfig>) => {
  apiConfig.baseUrl = config.baseUrl ?? apiConfig.baseUrl
}
